import { generateRandomId, paramCase } from '@dazn/peng-html5-tools-utils';
var cache = {};
/**
 * A very crude/minimal "css-in-js" type util for basic use cases only.
 */
var style = function (elements, block) {
    var cacheKey = block !== null && block !== void 0 ? block : JSON.stringify(elements);
    if (cacheKey in cache)
        return cache[cacheKey];
    var prefix = block !== null && block !== void 0 ? block : "_".concat(generateRandomId());
    var styleSheet = '';
    var selectors = Object.keys(elements).reduce(function (acc, elementName) {
        var namespacedClassName = "".concat(prefix, "_").concat(paramCase(elementName));
        var namespacedClassNameSelector = ".".concat(namespacedClassName);
        var css = elements[elementName];
        styleSheet += "".concat(css.replace(/&/g, namespacedClassNameSelector), "\n\n");
        acc[elementName] = namespacedClassName;
        return acc;
    }, {});
    cache[cacheKey] = selectors;
    if (typeof window !== 'undefined' && process.env['NODE_ENV'] !== 'TEST') {
        var styleElement = document.createElement('style');
        styleElement.innerHTML = styleSheet;
        document.head.appendChild(styleElement);
    }
    return selectors;
};
export { style };
//# sourceMappingURL=style.js.map